import React, { useEffect, useState } from "react";
import CustomButton from "../../common/CustomButton";
import AsteriskStyle from "../../Form/Tooltip/AsteriskStyle";
import useTeamName from "../../hooks/useTeamName";
import CustomSelect from "../../common/CustomSelect";
import { userRoleList } from "../../../Enum/UserRoleEnumConstants";
import { features } from "../../../config/featureConfig";

const UserInfoSidebar = ({
  handleUserCreate,
  handleUserUpdate,
  handleToggleClick,
  setUserForm,
  userForm,
  loading
}) => {
  const { teamNameList, fetchTeamName } = useTeamName();
  const isEdit = !!userForm?.userId;

 console.log("userForm", userForm);
  const previousTeam = Array.isArray(userForm.team)
    ? userForm.team.map((item) => ({
        value: item?.id,
        label: item?.name,
      }))
    : [];

  const previousRole = userForm.role
    ? {
        value: userForm.role,
        label:
          userRoleList.find((role) => role.value === userForm.role)?.label ||
          userForm.role,
      }
    : null;

  const [selectedTeam, setSelectedTeam] = useState(previousTeam || []);
  const [selectedRole, setSelectedRole] = useState(previousRole || null);

  useEffect(() => {
    if(!isEdit)
    {
      fetchTeamName();
    }
  }, []);

  const handleTeamChange = (selectedOption) => {
    setSelectedTeam(selectedOption);
  };

  const handleRoleChange = (selectedOption) => {
    setSelectedRole(selectedOption || null);
    setSelectedTeam([]); 
  };

  const showTeamSelect = ["ADMIN", "CMO", "LEAD UPLOADER"].includes(
    selectedRole?.value
  );

  const handleUserManage = () => {
    const teamArray = Array.isArray(selectedTeam)
      ? selectedTeam.map((item) => item.value)
      : selectedTeam
      ? [selectedTeam.value]
      : null;
  
    const userData = {
      name: userForm.name,
      role: selectedRole?.value,
      team: teamArray,
      emailId: userForm.email,
      employeeId: userForm.empId,
      phoneNumber: Number(userForm.phone),
      status: userForm.status,
      isIvr : userForm.isIvr,
    };
   
  
    if (isEdit) {
      handleUserUpdate(userForm?.userId, userData);
    } else {
      handleUserCreate(userData);
    }
  };
  
  
  console.log("selectedTeam", selectedTeam);

  const handlePhoneInput = (e) => {
    const onlyNums = e.target.value.replace(/\D/g, "");
    setUserForm((prev) => ({
      ...prev,
      phone: onlyNums,
    }));
  };



  return (
    <div className="flex flex-col gap-6 px-5">
      {/* Name */}
      <div className="flex items-center gap-4">
        <label className="w-32 text-sm font-medium text-gray-700">
          User Name <AsteriskStyle />
        </label>
        <input
          type="text"
          maxLength={30}
          placeholder="Enter User Name"
          value={userForm.name || ""}
          onChange={(e) =>
            setUserForm((prev) => ({ ...prev, name: e.target.value }))
          }
          className="flex-1 rounded-[10px]  py-2 px-3 input-focus"
        />
      </div>

      {/* Role */}
      <div className="flex items-center gap-4">
        <label className="w-32 text-sm font-medium text-gray-700">
          Role <AsteriskStyle />
        </label>
        <CustomSelect
          options={userRoleList}
          onChange={handleRoleChange}
          value={selectedRole}
          disabled={isEdit}
          placeholder="Select User Role"
          className="flex-1"
        />
      </div>

      {/* Team (conditional) */}
      {!showTeamSelect && (
        <div className="flex items-center gap-4">
          <label className="w-32 text-sm font-medium text-gray-700">
            Team <AsteriskStyle />
          </label>
          <CustomSelect
            options={teamNameList}
            isMulti={selectedRole?.value === "MD"}
            disabled={!selectedRole || isEdit}
            onChange={handleTeamChange}
            value={selectedTeam}
            placeholder={`${!selectedRole ? "First Select Role" : "Select Team"}`}
            className="flex-1"
          />
        </div>
      )}

      {/* Email */}
      <div className="flex items-center gap-4">
        <label className="w-32 text-sm font-medium text-gray-700">
          Email Id <AsteriskStyle />
        </label>
        <input
          type="email"
          value={userForm.email || ""}
          placeholder="Enter User Email"
          disabled={isEdit}
          onChange={(e) =>
            setUserForm((prev) => ({ ...prev, email: e.target.value }))
          }
          className="flex-1 rounded-[10px]  py-2 px-3 input-focus"        />
      </div>

      {/* Employee ID */}
      <div className="flex items-center gap-4">
        <label className="w-32 text-sm font-medium text-gray-700">
          Employee Id <AsteriskStyle />
        </label>
        <input
          type="text"
          maxLength={20}
          value={userForm.empId || ""}
          placeholder="Enter Employee Id"
          onChange={(e) =>
            setUserForm((prev) => ({
              ...prev,
              empId: e.target.value.toUpperCase(),
            }))
          }
          
          className="flex-1 rounded-[10px]  py-2 px-3 input-focus"     />
      </div>

      {/* Phone Number */}
      <div className="flex items-center gap-4">
        <label className="w-32 text-sm font-medium text-gray-700">
          Phone Number <AsteriskStyle />
        </label>
        <input
          type="tel"
          value={userForm.phone || ""}
          maxLength={10}
          placeholder="Enter Phone Number"
          onChange={handlePhoneInput}
          className="flex-1 rounded-[10px]  py-2 px-3 input-focus"      />
      </div>

    
       {/* Status Toggle */}

<div className="flex items-center gap-4">
        <label className="w-32 text-sm font-medium text-gray-700">Status</label>
         {userForm.status ?<div className="flex items-center gap-3">
        <span
            className={`text-sm font-medium ${
              userForm.status ? "" : "text-red-600"
            }`}
          >
            {"Deactive"}
          </span>
          <label className="relative inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              checked={userForm.status}
              onChange={(e) =>
              handleToggleClick(userForm.userId)
                 
              }
              className="sr-only peer"
            />
            <div
              className={`w-11 h-6 rounded-full peer-focus:outline-none after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border after:rounded-full after:h-5 after:w-5 after:transition-all ${
                userForm.status ? "bg-green-600" : "bg-red-500"
              } peer-checked:after:translate-x-full`}
            />
          </label>
          <span
            className={`text-sm font-medium ${
              userForm.status ? "text-green-600" : ""
            }`}
          >
            { "Active"}
          </span>
        </div> : (<>
         
         <div className="text-red-500">
          This user is not active
         </div>
        
        </>)}
      </div>


{/* {features.ivrCalls && (
  <div className="flex items-center gap-4">
        <label className="w-32 text-sm font-medium text-gray-700">IVR Call Access</label>
       <div className="flex items-center gap-3">
        <span
            className={`text-sm font-medium ${
              userForm.isIvr ? "" : "text-red-600"
            }`}
          >
            {"Disabled"}
          </span>
          <label className="relative inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              checked={userForm.isIvr}
             onChange={(e)=>{
              setUserForm((prev)=>(
                {
                  ...prev,
                  isIvr: e.target.checked
                }
              ))
             }}
              className="sr-only peer"
            />
            <div
              className={`w-11 h-6 rounded-full peer-focus:outline-none after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border after:rounded-full after:h-5 after:w-5 after:transition-all ${
                userForm.isIvr ? "bg-green-600" : "bg-red-500"
              } peer-checked:after:translate-x-full`}
            />
          </label>
          <span
            className={`text-sm font-medium ${
              userForm.isIvr ? "text-green-600" : ""
            }`}
          >
            { "Enabled"}
          </span>
        </div> 
      </div>
)} */}


      {/* <div className="text-sm">
        <p>
        <span className="text-red-500">*Note</span> - Logging password will be sent to users Email ID
        </p>
      </div> */}
   

      {/* Submit Button */}
      {/* {userForm.status && (
        <>
         <CustomButton
         isDisabled={loading}
        onClick={handleUserManage}
        
        label={`${isEdit ? "Update" : "Create"} User`}
        className="w-full flex justify-center "
      />
        </>
      )} */}
     
    </div>
  );
};

export default UserInfoSidebar;